import { ApiError } from '../../abstract/api-error';
import { isRecord } from './is-record';

/** The hub's code for "this DJI flight already has a spray record" (409, `detail.sprayRecordId`). */
export const FLIGHT_ALREADY_LINKED = 'FLIGHT_ALREADY_LINKED';

/**
 * `error` as an `ApiError` whose message is the hub's own, or `fallback` when the hub sent none
 * (network failure, empty body). The code, action and detail are kept.
 */
export function withFallbackMessage(error: unknown, fallback: string): ApiError {
  const apiError = ApiError.fromHttpError(error);
  const hasMessage = apiError.errors.some(message => message.trim() !== '');
  if (hasMessage || apiError.code === 'NETWORK_ERROR') {
    return apiError;
  }
  const fields = { code: apiError.code, action: apiError.action, detail: apiError.detail };
  return new ApiError(apiError.status, [], fields, fallback);
}

/** The spray record a flight is already linked to, from a `FLIGHT_ALREADY_LINKED` error; else `null`. */
export function alreadyLinkedSprayRecordId(error: unknown): string | null {
  if (!(error instanceof ApiError) || error.code !== FLIGHT_ALREADY_LINKED || !isRecord(error.detail)) {
    return null;
  }
  const id = error.detail['sprayRecordId'];
  return typeof id === 'string' && id !== '' ? id : null;
}
